
import  { useMemo, useState } from "react";
import { Button, PageHeader, Card, Loader, EmptyState } from "../../../components/ui";
import Pagination from "../../../components/ui/Pagination";
import { strings } from "../../../strings/strings";
import { editIcon, plusIcon, eyeIcon as EyeIcon } from "../../../assets/Icons/icons";

import AddHospitalModal from "./AddHospitalModal";
import ViewHospitalModal from "./ViewHospitalModal";

import { useAppQuery } from "../../../api/fetchClient";
import { GET_HOSPITAL } from "../../../api/url";
import { QUERY_KEYS } from "../../../api/queryKeys";

const Hospital = () => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [mode, setMode] = useState("add");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewHospital, setViewHospital] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleOpenAdd = () => {
    setMode("add");
    setSelectedHospital(null);
    setIsAddOpen(true);
  };

  const handleOpenEdit = (hospital) => {
    setMode("edit");
    setSelectedHospital(hospital);
    setIsAddOpen(true);
  };

  const handleCloseModal = () => {
    setIsAddOpen(false);
    setSelectedHospital(null);
    setMode("add");
  };

  const handleOpenView = (hospital) => {
    setViewHospital(hospital);
    setIsModalOpen(true);
  };

  const handleCloseView = () => {
    setIsModalOpen(false);
    setViewHospital(null);
  };

  const {
    data: hospitalRes,
    isLoading,
    isFetching,
 
  } = useAppQuery({
    queryKey: [QUERY_KEYS.HOSPITAL, currentPage, itemsPerPage],
    url: GET_HOSPITAL,
    method: "GET",
    params: { page: currentPage, limit: itemsPerPage },
  });
  const tableRows = useMemo(() => {
    return hospitalRes?.results?.data || [];
  }, [hospitalRes]);
  const paginationData = useMemo(() => {
    return hospitalRes?.results?.pagination || null;
  }, [hospitalRes]);

  return (
    <div>
      <div className="max-w-7xl mx-auto">
        <div className="sm:flex justify-between items-center">
          <PageHeader title={strings.hospital} description={strings.hospitalDescription} />

          <Button
            onClick={handleOpenAdd}
            variant="primary"
            size="md"
            className="mb-4 sm:mb-0 shadow-md hover:shadow-lg transition-shadow"
          >
            <img src={plusIcon} alt="Add" className="h-5 w-5 inline-block mr-2" />
            {strings.addNewHospital}
          </Button>
        </div>

        <Card>
          <div className="bg-white rounded-lg overflow-hidden">
            {isLoading ? (
              <div className="flex justify-center items-center py-20">
                <Loader />
              </div>
            ) : tableRows.length === 0 ? (
              <div className="px-6 py-8 text-sm text-gray-500">
                <EmptyState title={strings.emptyHcp} description={strings.emptyHcpDesctiption} />
              </div>
            ) : (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50 text-secondary">
                      <tr>
                        <th className="text-left uppercase px-6 py-3 font-bold text-xs">{strings.name}</th>
                        <th className="text-left uppercase px-6 py-3 whitespace-nowrap font-bold text-xs">
                          {strings.refferalCode}
                        </th>
                        <th className="text-left uppercase px-6 py-3 font-bold text-xs">{strings.country}</th>

                        <th className="text-left uppercase px-6 py-3 font-bold text-xs">{strings.city}</th>
                        <th className="text-right uppercase px-6 py-3 font-bold text-xs">{strings.action}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {tableRows.map((h, index) => (
                        <tr key={h?.id || index} className="border-t border-gray-200">
                          <td className="px-6 py-3 text-secondary font-medium whitespace-nowrap">{h?.name || "-"}</td>
                          <td className="px-6 py-3 text-secondary font-medium">{h?.referral_code || "-"}</td>
                          <td className="px-6 py-3 text-secondary font-medium">{h?.country || "-"}</td>

                          <td className="px-6 py-3 text-secondary font-medium">{h?.city || "-"}</td>

                          <td className="px-6 py-3 text-right">
                            <div className="inline-flex items-center gap-2">
                              <button
                                onClick={() => handleOpenView(h)}
                                className="p-2 hover:bg-gray-100 bg-grey rounded-md transition-colors"
                                title={strings.view}
                              >
                                <EyeIcon className="w-3 h-3 text-secondary" />
                              </button>

                              <button
                                onClick={() => handleOpenEdit(h)}
                                className="p-2 hover:bg-gray-100 bg-grey rounded-md transition-colors"
                                title={strings.edit}
                              >
                                <img src={editIcon} alt={strings.edit} className="w-3 h-3 min-w-[10px] min-h-[10px]" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {paginationData && (
                  <div className="py-4 border-t">
                    <Pagination pagination={paginationData} onPageChange={(page) => setCurrentPage(page)} />
                    {isFetching && <div className="mt-2 text-xs text-gray-500">{strings.loading}</div>}
                  </div>
                )}
              </>
            )}
          </div>
        </Card>

        <AddHospitalModal
          isOpen={isAddOpen}
          onClose={handleCloseModal}
          mode={mode}
          hospital={selectedHospital}
          onSuccess={() => {
            setCurrentPage(1);

          }}
        />

        <ViewHospitalModal isOpen={isModalOpen} onClose={handleCloseView} hospital={viewHospital} />
      </div>
    </div>
  );
};

export default Hospital;

